import React, { useEffect, useState } from "react";
import { renderInput } from "../../../../Common/FormComponents";
import { GetData, PostData, PutData } from "../../../../../utils/ApiInvoker";
import GenerateURL from "../../../../../utils/ApiUrlProvider";
import { useLoadingContext } from "../../../../../Context/LoadingContext";
import properties from "../../../../../Properties/Properties";
import { useNavigate, useParams } from "react-router-dom";
import {
  BasicInfoBLStage1val,
  BasicInfoBLStage2val,
  BasicInfoBLStage3val,
} from "../../../../Common/FormValidation/BusinessLoanServVal";
import { toast } from "react-toastify";
import { PartnerOrAssociate } from "../../../../../utils/Healpers";

const BasicInfoBusinessLoan = () => {
  const navigate = useNavigate();
  const { id, type } = useParams();
  const totalStage = 3;
  const [stage, setStage] = useState(1);
  const { showLoader, hideLoader } = useLoadingContext();

  const initialBasicInfoData = {
    first_name: "",
    last_name: "",
    spouse_name: "",
    mobile_number: "",
    marital_status: "false",
    father_name: "",
    mother_name: "",
    email: "",
    dob: "",
    pan_number: "",
    gender: "",
    personal_address: {
      house_address: "",
      city: "",
      state: "",
      pin_code: "",
      year_at_present_address: "",
      landmark: "",
    },
    current_address: {
      house_address: "",
      city: "",
      state: "",
      pin_code: "",
      year_at_present_address: "",
      landmark: "",
    },
    registered_as: "",
    has_additional_partners: "",
    aadhar_card: "",
    pan_card: "",
    poi: "",
    poa: "",
    photo: "",
    rent_agrrement: "",
    loan_amount: "",
    tenure_in_year: "",
  };
  const [basicInfoData, setBasicInfoData] = useState(null);
  const [basicInfoError, setBasicInfoError] = useState({
    ...initialBasicInfoData,
    marital_status: false,
    has_additional_partners: false,
  });
  const HandleBasicInfoChange = (e) => {
    const { name, value } = e.target;
    setBasicInfoError({ ...basicInfoError, [name]: "" });
    setBasicInfoData({ ...basicInfoData, [name]: value });
  };
  const [isCurrenntsame, setIsCurrentsame] = useState(false);
  const HandleAddresscopy = (e) => {
    setIsCurrentsame(!isCurrenntsame);
    if (e) {
      setBasicInfoData({
        ...basicInfoData,
        current_address: basicInfoData.personal_address,
      });
    } else {
      setBasicInfoData({
        ...basicInfoData,
        current_address: initialBasicInfoData.current_address,
      });
    }
  };

  const HandleSubmitSucess = (e) => {
    hideLoader();
    if (PartnerOrAssociate()) {
      navigate(`/partner/loan/businessloan/${e.id}/detail`);
    } else {
      navigate(`/user/loan/businessloan/${e.id}/detail`);
    }
    toast.success(
      type === undefined
        ? "Application Submitted Sucesfully"
        : "Edited Sucessfully",
      {
        autoClose: 1000,
      }
    );
  };
  const HandleSubmitError = (e) => {
    hideLoader();
    toast.error("Something went wrong", {
      autoClose: 1000,
    });
  };

  const HandleSubmitResponse = (e) => {
    e.preventDefault();
    showLoader();
    if (type === "edit") {
      const url = GenerateURL(
        { id: id },
        properties.api.BusinessLoanServices.EditUrl.UserBusinessLoanEdit
      );
      PutData(url, basicInfoData, HandleSubmitSucess, HandleSubmitError, false);
    } else {
      const url = GenerateURL(
        { id: id },
        properties.api.BusinessLoanServices.UserBusinessLoan
      );
      PostData(
        url,
        basicInfoData,
        HandleSubmitSucess,
        HandleSubmitError,
        false
      );
    }
  };

  const handleNextClick = (e) => {
    e.preventDefault();
    if (stage <= 2) {
      if (stage === 1) {
        const valid = BasicInfoBLStage1val(basicInfoData);
        if (valid.valid) {
          setStage((prev) => prev + 1);
        } else {
          setBasicInfoError((prev) => ({ ...prev, ...valid.errors }));
        }
      }
      if (stage === 2) {
        const valid = BasicInfoBLStage2val(basicInfoData);
        if (valid.valid) {
          setStage((prev) => prev + 1);
        } else {
          setBasicInfoError((prev) => ({ ...prev, ...valid.errors }));
        }
      }
    } else {
      const valid = BasicInfoBLStage3val(basicInfoData);
      console.log(valid);
      if (valid.valid) {
        HandleSubmitResponse(e);
      } else {
        setBasicInfoError((prev) => ({ ...prev, ...valid.errors }));
      }
    }
  };
  const HandlePrevClick = (e) => {
    e.preventDefault();
    setStage((prev) => prev - 1);
  };

  const HandleGetSucess = (res) => {
    setBasicInfoData({
      ...res,
      personal_address: res.personal_address
        ? res.personal_address
        : {
            house_address: "",
            city: "",
            state: "",
            pin_code: "",
            year_at_present_address: "",
            landmark: "",
          },
      current_address: res.current_address
        ? res.current_address
        : {
            house_address: "",
            city: "",
            state: "",
            pin_code: "",
            year_at_present_address: "",
            landmark: "",
          },
      has_additional_partners: res.has_additional_partners ? "true" : "false",
      marital_status: res.marital_status ? "true" : "false",
    });
  };
  const HandleGetError = (res) => {
    toast.error("Something went wrong", {
      autoClose: 1000,
    });
    navigate("/user/dashboard");
  };

  const GetInitialData = () => {
    const url = GenerateURL(
      { id: id },
      properties.api.BusinessLoanServices.EditUrl.UserBusinessLoanEdit
    );

    GetData(url, HandleGetSucess, HandleGetError, false, false);
  };

  useEffect(() => {
    if (id === undefined && type === undefined) {
      setBasicInfoData(initialBasicInfoData);
    } else {
      GetInitialData();
    }
  }, []);

  const registredAs = [
    { value: "", label: "Select One" },
    { value: "PROPRIETORSHIP", label: "Proprietorship" },
    { value: "PATNERSHIP", label: "Partnership" },
    { value: "COMPANY", label: "Company" },
  ];

  return (
    <div className="p-5 w-full md:w-8/12 h-full pt-20  ">
      <h1 className="text-2xl md:text-3xl pl-2 my-2 border-l-4  text-slate-800 font-sans font-bold  border-logo-blue mb-5  rounded-sm  ">
        Business Loan
      </h1>
      <div className="flex items-center w-full border shadow-md flex-col justify-center rounded-lg  bg-white  ">
        <div className="flex items-start w-full flex-col  px-6 py-3  bg-logo-blue bg-opacity-90 rounded-t-lg ">
          <p className="w-11/12 py-3 text-xl text-left capitalize text-white ">
            Basic Details
          </p>
          <div className="flex items-center justify-between w-full flex-row ">
            <div className="w-full bg-white rounded-full h-1.5 overflow-hidden">
              <div
                className="bg-logo-orange h-1.5 rounded-full transition-width duration-800"
                style={{
                  width: "0%",
                  transition: "width 1s ease-in-out",
                  width: `${(stage / totalStage) * 100}%`,
                }}
              ></div>
            </div>
          </div>
        </div>
        <div className="flex items-center w-full flex-row justify-center rounded-lg  bg-white">
          {basicInfoData && (
            <form className="w-full h-full  p-4 ">
              {stage === 1 && (
                <>
                  <p className="text-xl rounded-md px-10 py-1 bg-logo-blue bg-opacity-10 my-2  font-medium text-logo-orange">
                    Personal Info
                  </p>

                  {renderInput("STRING", {
                    label: "First Name",
                    name: "first_name",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.first_name,
                    error: basicInfoError.first_name,
                    isrequired: true,
                  })}
                  {renderInput("STRING", {
                    label: "Last Name",
                    name: "last_name",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.last_name,
                    error: basicInfoError.last_name,
                    isrequired: true,
                  })}
                  {renderInput("STRING", {
                    label: "Mother Name",
                    name: "mother_name",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.mother_name,
                    error: basicInfoError.mother_name,
                    isrequired: true,
                  })}
                  {renderInput("STRING", {
                    label: "Father Name",
                    name: "father_name",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.father_name,
                    error: basicInfoError.father_name,
                    isrequired: true,
                  })}
                  {renderInput("DOB", {
                    label: "Date of Birth",
                    name: "dob",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.dob,
                    error: basicInfoError.dob,
                    isrequired: true,
                  })}

                  {renderInput("INTEGER", {
                    label: "Mobile Number (Aadhaar linked)",
                    name: "mobile_number",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.mobile_number,
                    error: basicInfoError.mobile_number,
                    isrequired: true,
                  })}
                  {renderInput("STRING", {
                    label: "Email",
                    name: "email",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.email,
                    error: basicInfoError.email,
                    isrequired: true,
                  })}
                  {renderInput("STRING", {
                    label: "Pan Number",
                    name: "pan_number",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.pan_number,
                    error: basicInfoError.pan_number,
                    isrequired: true,
                  })}
                  {renderInput("SELECT", {
                    label: "Gender",
                    name: "gender",
                    options: [
                      { label: "Male", value: "male" },
                      { label: "Female", value: "female" },
                      { label: "others", value: "others" },
                    ],
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.gender,
                    error: basicInfoError.gender,
                    isrequired: true,
                  })}
                  {renderInput("BOOLEAN", {
                    label: "Are You Married",
                    name: "marital_status",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.marital_status,
                    error: basicInfoError.marital_status,
                    isrequired: true,
                  })}
                  {basicInfoData.marital_status === "true" && (
                    <>
                      {renderInput("STRING", {
                        label: "Spouse/Husband Name",
                        name: "spouse_name",
                        onChange: HandleBasicInfoChange,
                        value: basicInfoData.spouse_name,
                        error: basicInfoError.spouse_name,
                        isrequired: true,
                      })}
                    </>
                  )}
                </>
              )}
              {stage === 2 && (
                <>
                  <p className="text-xl rounded-md px-10 py-1 bg-logo-blue bg-opacity-10 my-2  font-medium text-logo-orange">
                    Permanent Address
                  </p>
                  {renderInput("ADDRESS", {
                    label: "Address",
                    name: "personal_address",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.personal_address,
                    error: basicInfoError.personal_address,
                    isrequired: true,
                  })}
                  {renderInput("YESNO", {
                    label: "Current address is same as Permanent",
                    onChange: HandleAddresscopy,
                    isrequired: true,
                  })}
                  <p className="text-xl rounded-md px-10 py-1 bg-logo-blue bg-opacity-10 my-2  font-medium text-logo-orange">
                    Current Address
                  </p>
                  {renderInput("ADDRESS", {
                    label: "Address",
                    name: "current_address",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.current_address,
                    error: basicInfoError.current_address,
                    isrequired: true,
                    ischanged: isCurrenntsame,
                    isCurrent: true,
                  })}
                </>
              )}
              {stage === 3 && (
                <>
                  <p className="text-xl rounded-md px-10 py-1 bg-logo-blue bg-opacity-10 my-2  font-medium text-logo-orange">
                    Loan Detail Info
                  </p>
                  {renderInput("DROP_DOWN", {
                    label: "Registered As",
                    name: "registered_as",
                    options: registredAs,
                    value: basicInfoData.registered_as,
                    error: basicInfoError.registered_as,
                    onChange: HandleBasicInfoChange,
                    isrequired: true,
                  })}
                  {renderInput("STRING", {
                    label: "Tenure in months",
                    name: "tenure_in_year",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.tenure_in_year,
                    error: basicInfoError.tenure_in_year,
                    isrequired: true,
                  })}
                  {renderInput("STRING", {
                    label: "Loan Amount",
                    name: "loan_amount",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.loan_amount,
                    error: basicInfoError.loan_amount,
                    isrequired: true,
                  })}

                  {renderInput("BOOLEAN", {
                    label: "Has additional Partners",
                    name: "has_additional_partners",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.has_additional_partners,
                    error: basicInfoError.has_additional_partners,
                    isrequired: true,
                  })}
                  <p className="text-xl rounded-md px-10 py-1 bg-logo-blue bg-opacity-10 my-2  font-medium text-logo-orange">
                    Basic Documents
                  </p>
                  {renderInput("FILE_UPLOAD", {
                    label: "Pan Card",
                    name: "pan_card",
                    code: "pan_card",
                    value: basicInfoData.pan_card,
                    onChange: HandleBasicInfoChange,
                    error: basicInfoError.pan_card,
                    onlyId: true,
                    isrequired: false,
                    validations: {
                      file_size: "10MB",
                      file_type: ["jpg", "png", "pdf", "heic", "jpeg"],
                      isrequired: false,
                    },
                  })}
                  {renderInput("FILE_UPLOAD", {
                    label: "Aadhaar card",
                    name: "aadhar_card",
                    code: "aadhar_card",
                    onChange: HandleBasicInfoChange,
                    value: basicInfoData.aadhar_card,
                    error: basicInfoError.aadhar_card,
                    onlyId: true,
                    isrequired: false,
                    validations: {
                      file_size: "10MB",
                      file_type: ["jpg", "png", "pdf", "heic", "jpeg"],
                      isrequired: false,
                    },
                  })}
                  {renderInput("FILE_UPLOAD", {
                    label: "Proof Of Identity",
                    name: "poi",
                    code: "poi",
                    value: basicInfoData.poi,
                    onChange: HandleBasicInfoChange,
                    error: basicInfoError.poi,
                    onlyId: true,
                    isrequired: false,
                    validations: {
                      file_size: "10MB",
                      file_type: ["jpg", "png", "pdf", "heic", "jpeg"],
                      is_required: false,
                    },
                  })}
                  {renderInput("FILE_UPLOAD", {
                    label: "Proof of Address",
                    name: "poa",
                    code: "poa",
                    value: basicInfoData.poa,
                    onChange: HandleBasicInfoChange,
                    error: basicInfoError.poa,
                    onlyId: true,
                    isrequired: false,
                    validations: {
                      file_size: "10MB",
                      file_type: ["jpg", "png", "pdf", "heic", "jpeg"],
                      is_required: false,
                    },
                  })}
                  {renderInput("FILE_UPLOAD", {
                    label: "Photo",
                    name: "photo",
                    code: "photo",
                    value: basicInfoData.photo,
                    onChange: HandleBasicInfoChange,
                    error: basicInfoError.photo,
                    onlyId: true,
                    isrequired: false,
                    validations: {
                      file_size: "10MB",
                      file_type: ["jpg", "png", "pdf", "heic", "jpeg"],
                      is_required: false,
                    },
                  })}
                  {renderInput("FILE_UPLOAD", {
                    label: "Rent Agreement",
                    name: "rent_agrrement",
                    code: "rent_agrrement",
                    value: basicInfoData.rent_agrrement,
                    onChange: HandleBasicInfoChange,
                    error: basicInfoError.rent_agrrement,
                    onlyId: true,
                    isrequired: false,
                    validations: {
                      file_size: "10MB",
                      file_type: ["jpg", "png", "pdf", "heic", "jpeg"],
                      is_required: false,
                    },
                  })}
                </>
              )}
              <div className="mt-10 flex  flex-row-reverse gap-3 w-full items-center justify-between">
                <button
                  onClick={handleNextClick}
                  className={`${
                    stage === totalStage ? "bg-green-500" : "bg-blue-600"
                  } text-white px-4 py-2 rounded-md`}
                >
                  {stage === totalStage ? "Submit" : "Next"}
                </button>
                {stage !== 1 && (
                  <button
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                    onClick={HandlePrevClick}
                  >
                    Prev
                  </button>
                )}
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default BasicInfoBusinessLoan;
